import { render, staticRenderFns } from "./TaskManagerWidget.vue?vue&type=template&id=93a1a336&scoped=true"
import script from "./TaskManagerWidget.vue?vue&type=script&lang=js"
export * from "./TaskManagerWidget.vue?vue&type=script&lang=js"
import style0 from "./TaskManagerWidget.vue?vue&type=style&index=0&id=93a1a336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a1a336",
  null
  
)

export default component.exports